<template>
  <div>
    <div class="row">
      <div class="col-md-6" style="display: flex;">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
        </h4>
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="col-md-4" style="display: flex;">
        <label for="">Курс</label>
        <input @focus="show" type="text" :disabled="changedisabled" v-model="datas.dollar_rate" class="kurs">
      </div>
      <div class="col-md-2 end">
        <!-- <router-link class="btn btn-danger" :to="{ path: '/refund/index' }"> -->
          <button type="button" class="closebutton btn btn-danger" @click="Closing()">
            <b-icon icon="x-lg"></b-icon>
          </button>
        <!-- </router-link> -->
      </div>
    </div>
    <div class="rowform">
      <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input type="number" :disabled="changedisabled" class="input100" v-model="datas.number">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Вақт')}}</label>
          <input type="datetime-local" :disabled="true" class="input100" :value="SetDatetime(datas.created_at)">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Склад</label>
          <v-select :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            v-model="datas.sklad_id" :disabled="skladhave" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Клиент</label>
          <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
            :options="kontragentlist" v-model="datas.kontragent_id" :reduce="name => name.id" label="name">
            <template #list-footer>
              <li style="text-align: center;font-weight:bold;">
                f4 {{ $t("умумий рўйхат") }}
              </li>
            </template>
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button :disabled="changedisabled" type="button" class="modallist" v-b-modal.modal-kontragentlist>
                <b-icon icon="three-dots"></b-icon>
              </button>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
                <button type="button" class="pluss" @click="kontragent.name = search" v-b-modal.modal-kontragent>
                  +
                </button>
                <b>insert</b>
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>{{ $t("Тўлов тури") }}</label>
          <v-select :clearable="false" @input="Changepricetype()" :disabled="changedisabled" class="form-control-sm required md-input"
            :options="paytypelist" v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
            <template #list-footer>
              <li style="text-align: center;font-weight:bold;">
                f4 {{ $t("умумий рўйхат") }}
              </li>
            </template>
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button :disabled="changedisabled" type="button" class="modallist" v-b-modal.modal-paytypelist>
                <b-icon icon="three-dots"></b-icon>
              </button>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>{{ $t("Нарх тури") }}</label>
          <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input needt"
            :options="pricetypelist" @input="Changepricetype()" v-model="datas.price_type" :reduce="name => name.id" label="name"></v-select>
        </span>
      </div>
    </div>
    
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead style="width: calc(100% - 19px)!important;">
              <tr>
                <th class="column0">№</th>
                <th class="column1-5">Штрих код</th>
                <th class="column2">Товар</th>
                <th class="column1">{{ $t("Кол.") }}</th>
                <th class="column1">{{ $t("Қолдиқ") }}</th>
                <th class="column1">{{ $t("Нарх") }}</th>
                <th class="column1-5">Сумма</th>
                <th class="column0"></th>
              </tr>
            </thead>
            <tbody>
              <div :totalHeight="500" :defaultHeight="50"
                style="overflow-y: scroll;width: 100%;height: calc(100vh - 492px)!important;">
                <tr :style="{ height: `${index / 1000 + 10}px` }" v-for="(item, index) in datas.refund_table"
                  :key="index">
                  <td class="column0">{{ index + 1 }}</td>
                  <td class="column1-5">
                    <input @focus="show" :disabled="changedisabled" class="table-input" type="text" v-model="item.shtrix_kod"
                      @change="Shtrix(index)" />
                  </td>
                  <td class="column2">
                    <v-select :disabled="changedisabled" v-if="productlist != null" :filter-by="$store.state.myFilter"
                      :clearable="false"   class="form-control-sm required" @search="query => (search = query)"
                      :options="paginated" menu-props="auto" v-model="item.product_id"
                      :reduce="extra_name => extra_name.id" label="extra_name" @input="Productchange(index)">
                      <template #list-footer>
                        <li style="text-align: center;font-weight:bold;">
                          f4 {{ $t("умумий рўйхат") }}
                        </li>
                      </template>
                      <template #selected-option-container="{option}">
                        <div class="vs__selected">
                          <span v-if="typeof option.extra_name === 'number'">{{
                            Label(option.extra_name)
                            }}</span><span v-else>{{ option.extra_name }}</span>
                        </div>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"></span>
                        <button :disabled="changedisabled" type="button" class="modallist" @click="Selectproduct(index)">
                          <b-icon icon="three-dots"></b-icon>
                        </button>
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          <em><b>{{ search }}</b></em>
                          {{ $t("бўйича маьлумот йўқ") }}
                          <button type="button" class="pluss" @click="CreateProduct(index, search)">
                            +</button><b>Insert</b>
                        </template>
                        <em style="opacity: 0.5" v-else>{{
                          $t("Маьлумот йўқ")
                          }}</em>
                      </template>
                      <template #search="{ search, searching }">
                        <template v-if="searching">
                          <em><b>{{ search }}</b></em>
                          <input @focus="show" class="vs__search" v-bind="attributes" v-on="events" />
                        </template>
                      </template>
                    </v-select>
                  </td>
                  <td class="column1">
                    <input  @focus="show" :disabled="changedisabled" type="number" v-model="item.count" class="table-input"
                      separator="space" @input="Changecount(index)" v-bind:precision="3">
                  </td>
                  <td class="column1 kol">
                    {{ item.current_balance }}
                  </td>
                  <td class="column1">
                    <input  type="number" @focus="show"  :disabled="changedisabled" separator="space" v-model="item.price"
                      class="table-input kol" @change="Changeprice(index)" v-bind:precision="2">
                  </td>
                  <td class="column1-5 kol">{{ item.summa | numFormat("0.00") }}</td>
                  <td class="column0">
                    <a v-if="changedisabled==false" href="javascript:void(0)" class="circul trash"
                      @click="Trashitem(index)">
                      <b-icon icon="trash"></b-icon>
                    </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="rowform">
      <div class="col-md-4 topheader">
        <span style="border: none !important;">
          <payment-splitter
            v-model="datas.pay_table"
            :paytypes="paytypelist"
            :expected-total="parseFloat(datas.summa) - parseFloat(datas.skidka_summa) || 0"
            @input="onPaymentSplit"
          />
        </span>
      </div>
      <div class="col-md-1 topheader">
        <span>
          <label>Скидка</label>
          <input type="number" @focus="show" :disabled="changedisabled" separator="space" v-model="datas.skidka_summa" class="table-input end"
            v-bind:precision="0">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Комментарий</label>
          <input type="text" @focus="show" :disabled="changedisabled" v-model="datas.comment" class="input100">
        </span>
      </div>
      <div class="col-md-1 topminus">
        <span>{{$t('Сони')}}</span>
        <h4>{{datas.count_all}}</h4>
      </div>
      <div class="col-md-1 end topminus">
        <span>Сумма</span>
        <h4>{{datas.summa}}</h4>
      </div>
      <div class="col-md-5 formbottom">
        <button :disabled="changedisabled" class="btn btn-success addrow" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" class="btn btn-success" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button :disabled="changedisabled" class="btn mybtn" id="chek" type="button" @click="Savedokument('print')">
          <b-icon icon="printer"></b-icon>
        </button>
        <button :disabled="changedisabled" class="mybtn btn saved" type="button" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
      </div>
    </div>
    <div class="col-md-12 vozvrat">
      <vue-touch-keyboard :options="options" :layout="layout1" :cancel="hide" :accept="accept" :input="input" />
      </div>
    <div id="demo"></div>
    <b-modal id="modal-shtrix" title="Товар" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="row">
        <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter"
          ref="inputText2" />
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t("Номи") }}</th>
              <th>{{ $t("Қолдиқ") }}</th>
              <th>{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
              <th>{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
              <th>Штрих</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filteredRows" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable" @click="
                      datas.refund_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.extra_name }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.refund_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.balance }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.refund_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].chakana_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.refund_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].optom_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.refund_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.shtrix_table[0]">
                  {{ item.shtrix_table[0].shtrix_kod }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.refund.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  import PaymentSplitter from "../../components/PaymentSplitter.vue";
  export default {
    name: "RefundForm",
    mixins: [print],
    components: { PaymentSplitter },
    data() {
      return {
        visible: false,
        input: null,
        options: {
          useKbEvents: false,
          preventClickEvent: false
        },
        layout1: {
          _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control" },
            "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control" },
            "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control" },
            "shiftlru": { keySet: "shifted_ru", text: "Shift", width: 100, classes: "control" },
            "shiftrru": { keySet: "shifted_ru", text: "Shift", width: 100, classes: "control" },
            "ru": { keySet: "default_ru", text: "ru", width: 40, classes: "control featured" },
            "eng": { keySet: "default", text: "eng", width: 40, classes: "control featured" },
            "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control" },
            "capsru": { keySet: "capsed_ru", text: "Caps lock", width: 80, classes: "control" },
            "space": { key: " ", text: "Space", width: 180 },
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control" },
            "enter": { func: "enter", key: "\r\n", text: "Enter", width: 80, classes: "control" },
            "backspace": { func: "backspace", classes: "control backspace", width: 65 }
          },

          default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{caps} a s d f g h j k l ; ' {enter}",
            "{shiftl} z x c v b n m , . / {shiftr}",
            "{ru} {space} "
          ],
          shifted: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            "{caps} A S D F G H J K L : \" {enter}",
            "{shiftl} Z X C V B N M < > ? {shiftr}",
            "{ru} {space} "
          ],
          capsed: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Q W E R T Y U I O P [ ] \\",
            "{caps} A S D F G H J K L ; ' {enter}",
            "{shiftl} Z X C V B N M , . / {shiftr}",
            "{ru} {space} "
          ],
          shifted_ru: [
            "Ё ! \" № ; % : ? * ( ) _ + {backspace}",
            "{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ |",
            "{capsru} Ф Ы В А П Р О Л Д Ж Э {enter}",
            "{shiftlru} Я Ч С М И Т Ь Б Ю , {shiftrru}",
            "{eng} {space} "
          ],
          default_ru: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} й ц у к е н г ш щ з х ъ \\",
            "{capsru} ф ы в а п р о л д ж э {enter}",
            "{shiftlru} я ч с м и т ь б ю . {shiftrru}",
            "{eng} {space} "
          ],
          capsed_ru: [
            "Ё 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ \\",
            "{capsru} Ф Ы В А П Р О Л Д Ж Э {enter}",
            "{shiftlru} Я Ч С М И Т Ь Б Ю . {shiftrru}",
            "{eng} {space} "
          ]
        },
        kontragent: "",
        shtrixlist: [],
        settedindex: null,
        pricesettings: "",
        sklad: "",
        paytype: "",
        filter: "",
        focusset: "",
        kontragentlist: [],
        skladlist: [],
        paytypelist: [],
        regionlist: [],
        pricetypelist: [
          { id: "optom", name: "Оптом" },
          { id: "chakana", name: "Чакана" }
        ],
        showDialog: false
      };
    },
    props: ["datas"],
    created: function () {
      let self = this;
      self.$root.$refs.refund = self;
      self.Pricesettings();
      self.$root.$on("kontragentone", function (getdata) {
        self.kontragent = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        self.kontragentlist = getdata;
      });
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
    },
    mounted: function () {
      this.SetRule('/refund/index');
      // pay_table boshlang'ich holatini hardcoded ustunlardan qurish (eski yozuvlar uchun)
      let self = this;
      if (!self.datas.pay_table || !Array.isArray(self.datas.pay_table) || self.datas.pay_table.length === 0) {
        const init = [];
        if (parseFloat(self.datas.cash_summa) > 0) init.push({ pay_type_id: 1, summa: parseFloat(self.datas.cash_summa) });
        if (parseFloat(self.datas.plastic_summa) > 0) init.push({ pay_type_id: 2, summa: parseFloat(self.datas.plastic_summa) });
        if (parseFloat(self.datas.dollar_summa) > 0) init.push({ pay_type_id: 3, summa: parseFloat(self.datas.dollar_summa) });
        self.$set(self.datas, 'pay_table', init);
      }

      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.datas.refund_table[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          this.Productchange(this.$store.state.selected_index);
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
          localStorage.setItem("created_at_dok", this.datas.created_at);
          this.Focus();
        }, 1000);
    },
    methods: {
      onPaymentSplit(payTable) {
        let cash = 0, plastic = 0, dollar = 0;
        for (const row of (payTable || [])) {
          const s = parseFloat(row.summa) || 0;
          if (s <= 0) continue;
          if (row.pay_type_id === 1) cash += s;
          else if (row.pay_type_id === 2) plastic += s;
          else if (row.pay_type_id === 3) dollar += s;
        }
        this.$set(this.datas, 'cash_summa', cash);
        this.$set(this.datas, 'plastic_summa', plastic);
        this.$set(this.datas, 'dollar_summa', dollar);
      },
      Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        window.close();
        // this.$router.push({ name: "Кирим" });
      },
      Closing(){
      if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      window.close();
    } else {
      this.$bvModal.show("modal-close");
    }
    },
      accept(text) {
          alert("Input text: " + text);
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
        },
      Changepricetype(){
        let self=this;
        self.datas.summa = 0;
        self.datas.count_all = 0;
        this.datas.refund_table.forEach(function (item, value) {
          if (item.product_id > 0) {
          item.price = 0;
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          item.current_balance = response.data.balance;
          if (self.datas.price_type == "chakana") {
            if (self.pricesettings.chakana_price_type == 1) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_price / self.datas.dollar_rate;
              } else {
                item.price = response.data.chakana_price;
              }
            } else if (self.pricesettings.chakana_price_type == 2) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_dollar_price;
              } else {
                item.price = response.data.chakana_dollar_price * self.datas.dollar_rate;
              }
            } else if (self.pricesettings.chakana_price_type == 3) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_dollar_price;
              } else {
                item.price = response.data.chakana_price;
              }
            }
          } else {
            if (self.pricesettings.optom_price_type == 1) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_price / self.datas.dollar_rate;
              } else {
                item.price = response.data.optom_price;
              }
            } else if (self.pricesettings.optom_price_type == 2) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_dollar_price;
              } else {
                item.price = response.data.optom_dollar_price * self.datas.dollar_rate;
              }
            } else if (self.pricesettings.optom_price_type == 3) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_dollar_price;
              } else {
                item.price = response.data.optom_price;
              }
            }
          }
          item.summa=item.price*item.count;
          self.datas.summa += parseFloat(item.summa);
          self.datas.count_all += parseFloat(item.count);
        });
        }
        });
      },
      Pricesettings() {
        let self = this;
        axios.get("api/v1/sklads/id/1").then(function (response) {
          self.pricesettings = { common_price_type: response.data.common_price_type, chakana_price_type: response.data.chakana_price_type, optom_price_type: response.data.optom_price_type };
        });
      },
      CreateProduct(index, search) {
        localStorage.setItem("product_name", search);
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал create" });
        const myWindow = window.open(routeData.href, "", "width=300,height=300");
        myWindow.opener;
      },
      Shoved() {
        let self = this;
        $(document).on("focusout", function (e) {
          if ($(e.target).attr("class") == "vs__search") {
            if (self.focusset == "") {
              self.focusset = e.target;
            }
          }
        });
        self.$refs.inputText2.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          var classs = $(":focus");
          var rrr = $("body")
            .find("input,select,textarea,button")
            .filter(":visible");
          if (classs.attr("class") == "vs__search") {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              var focused = rrr.eq(rrr.index(classs) + 2);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          } else if (classs.attr("class") == undefined) {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              focused = rrr.eq(rrr.index($(self.focusset)) + 3);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          }
        }, 100);
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.summa -= this.datas.refund_table[index].kontragent_summa;
          this.datas.refund_table.splice(index, 1);
          this.Summa();
        }
      },
      Productchange(index) {
        let self = this;
        var item = self.datas.refund_table[index];
        if(item.product_id>0){
        item.price = 0;
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          item.current_balance = response.data.balance;
          if (self.datas.price_type == "chakana") {
            if (self.pricesettings.chakana_price_type == 1) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_price / self.datas.dollar_rate;
              } else {
                item.price = response.data.chakana_price;
              }
            } else if (self.pricesettings.chakana_price_type == 2) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_dollar_price;
              } else {
                item.price = response.data.chakana_dollar_price * self.datas.dollar_rate;
              }
            } else if (self.pricesettings.chakana_price_type == 3) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.chakana_dollar_price;
              } else {
                item.price = response.data.chakana_price;
              }
            }
          } else {
            if (self.pricesettings.optom_price_type == 1) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_price / self.datas.dollar_rate;
              } else {
                item.price = response.data.optom_price;
              }
            } else if (self.pricesettings.optom_price_type == 2) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_dollar_price;
              } else {
                item.price = response.data.optom_dollar_price * self.datas.dollar_rate;
              }
            } else if (self.pricesettings.optom_price_type == 3) {
              if (self.datas.pay_type_id == 3) {
                item.price = response.data.optom_dollar_price;
              } else {
                item.price = response.data.optom_price;
              }
            }
          }
        });
        self.Setshtrix1(item);
        self.Changeprice(index);
      }
      },
      Focus() {
        $(".table-input")
          .not(".needt")
          .eq(0)
          .focus();
      },
      Shtrix(index) {
        let self = this;
        var shtrix = self.datas.refund_table[index].shtrix_kod;
        axios({
          method: "post",
          url: "api/v1/product/shtrix2/" + shtrix,
          data: { sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          if (!response.data[0]) {
          } else if (response.data[1]) {
            self.settedindex = index;
            self.shtrixlist = response.data;
            self.$bvModal.show("modal-shtrix");
          } else {
            self.datas.refund_table[index].product_id =
              response.data[0].product_id;
            self.Productchange(index);
            var classs = $(":focus");
            var rrr = $("body")
              .find("input,select,textarea,button")
              .filter(":visible");
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        const myWindow = window.open(routeData.href, "","width=1200, height=1000");
        myWindow.opener;
      },
      Changeprice(index) {
        var item = this.datas.refund_table[index];
        if (item.count > 0) {
          item.summa = item.price * item.count;
          if (this.datas.refund_table.length == index + 1) {
            this.Addtable('price');
          }
        }
        this.Summa();
      },
      Changecount(index) {
        var item = this.datas.refund_table[index];
        let self = this;
        // if(item.current_balance<item.count){
        //   item.count = item.current_balance;
        //   self.$store.state.errors = "Қолдиқ мавжуд емас";
        // }
        if (item.price > 0) {
          this.Changeprice(index);
        }
      },
      Addtable(type = 'default') {
        this.datas.refund_table.push({
          product_id: 0,
          count: 0,
          price: 0,
          summa: 0,
          shtrix_kod: null,
          current_balance: 0
        });
        if (type == 'default') {
          this.Tablefocus();
        }
      },
      Summa() {
        this.datas.summa = 0;
        this.datas.count_all = 0;
        let self = this;
        this.datas.refund_table.forEach(function (key, value) {
          self.datas.summa += parseFloat(key.summa);
          self.datas.count_all += parseFloat(key.count);
        });
      },
      Savedokument(type = 'default') {
        let self = this;
        let data=0;
        if (self.datas.pay_type_id == 3) {
          data = this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa / this.datas.dollar_rate - this.datas.plastic_summa / this.datas.dollar_rate - this.datas.dollar_summa;
        } else {
          data = this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa - this.datas.plastic_summa - this.datas.dollar_summa * this.datas.dollar_rate;
        }
        if (self.datas.kontragent_id == 0 && data > 0) {
          self.$store.state.errors = self.$t("Тўлов тўлиқ амалга оширилмаган");
        }else{
        // if (self.rule.change == true) {
          if (this.$route.path == "/refund/create") {
            var methods = "post";
            var action = "api/v1/refund";
            self.datas.updated_at = new Date()
              .valueOf()
              .toString()
              .slice(0, 10);
          } else {
            var methods = "patch";
            var action = "api/v1/refund/id/" + self.$route.params.id;
            if (self.$store.state.saved == 1) {
              self.datas.updated_at = new Date()
                .valueOf()
                .toString()
                .slice(0, 10);
            }
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            if (type == "print") {
              // let myWindow;
              self.$router.push({path:'/refund/print/' + response.data.id});
              // myWindow = window.open(
                // '#/refund/print/' + response.data.id,
                // "_blank",
                // "width=1000, height=1000"
              // );
              // window.close();
            } else if (type == 'save') {
              self.$router.push({ path: "/refund/update/" + response.data.id });
            } else {
              window.close();
            }
          });
        }
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    },
    computed: {
      SelectedProduct() {
        return this.$store.state.selected_product;
      },
      filteredRows() {
        return this.shtrixlist.filter(row => {
          const name = row.name.toString().toLowerCase();
          const searchTerm = this.filter.toLowerCase();

          return name.includes(searchTerm);
        });
      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Productchange(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .md-card-content>.table.table-bordered tbody {
    display: block;
    height: 70vh;
    overflow-y: scroll;
  }

  .md-card-content>.table.table-bordered thead,
  .md-card-content>.table.table-bordered tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
</style>